import { render, staticRenderFns } from "./Grade6Expectation.vue?vue&type=template&id=749d66d7&scoped=true&"
import script from "./Grade6Expectation.vue?vue&type=script&lang=js&"
export * from "./Grade6Expectation.vue?vue&type=script&lang=js&"
import style0 from "./Grade6Expectation.vue?vue&type=style&index=0&id=749d66d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749d66d7",
  null
  
)

export default component.exports